<template>
	<div class="container">
		<headerBox :current="4"></headerBox>
		<bannerBox ref="bannerChild"></bannerBox>
		<div class="content_box">
			<div class="search_box">
				<div>人员姓名：<Input v-model="form.name" placeholder="" style="width: 180px"></Input></div>
				<div>证书编号：<Input v-model="form.certno" placeholder="" style="width: 180px"></Input></div>
				<div>单位名称：<Input v-model="form.dw" placeholder="" style="width: 180px"></Input></div>
				<div class="btn1" @click="getCyry">查询</div>
				<div class="btn2" @click="toReset">重置</div>
			</div>
			<Tabs value="name1">
				<Tab-pane label="从业人员库" name="name1">
					<div class="cell_box">
						<div class="cell th">
							<div v-for="(it,i) in th" :key="i">{{it}}</div>
						</div>
						<div class="cell td" v-for="(it,i) in ryList" :key="i" @click="goDetail(it)">
							<div>{{params.pageSize*params.pageNo-params.pageSize+i+1}}</div>
							<div>{{it.name}}</div>
							<div>{{it.certno}}</div>
							<div>{{it.shrq}}</div>
							<div>{{it.yxqz}}</div>
							<div>{{it.dw}}</div>
						</div>
					</div>
					<div v-if="ryList.length==0" class="common_excel_no_more">暂无内容~</div>
					<Page v-if="ryList.length!=0" class="common_page_box" @on-change="changePage" :total="total" :current="params.pageNo" :page-size="params.pageSize"
						show-total></Page>
				</Tab-pane>
			</Tabs>
		</div>
		<footerBox></footerBox>
		<Back-top :height="100" :bottom="200">
			<div class="iconfont icon-shangjiantou"></div>
		</Back-top>
		<vipLogin ref="vipbox"></vipLogin>
	</div>
</template>

<script>
	import bannerBox from '@/components/banner.vue'
	import headerBox from '@/components/header.vue'
	import footerBox from '@/components/footer.vue'
	import vipLogin from '@/components/vip_login.vue'
	import {
		getCyry
	} from '@/api/home/index'
	export default {
		name: 'home',
		components: {
			bannerBox,
			headerBox,
			footerBox,
			vipLogin
		},
		data() {
			return {
				th: ['序号', '姓名', '证书编号', '审核日期', '有效期至', '所在单位'],
				total: 0,
				params: {
					pageNo: 1,
					pageSize: 10
				},
				form:{},
				ryList:[]
			}

		},
		mounted() {
			this.getCyry();
			this.$refs["bannerChild"].locationList=['从业人员','从业人员库'];
		},
		methods: {
			changePage(e) {
				this.params.pageNo = e;
				this.getCyry();
			},
			getCyry(){
				getCyry({...this.params,...this.form}).then(res => {
					if (res.code == 200 || res.code == 0) {
						this.ryList = res.result.records;
						this.total = res.result.total;
					}else if(res.code == 401){
						this.$refs['vipbox'].showLogin = true;
						this.$refs['vipbox'].goRyc = true;
					}
				})
			},
			toReset(){
				this.form = {}
			},
			goDetail(it){
				this.$router.push({
					name:'people_detail',
					query:{
						certno:it.certno
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .ivu-tabs-nav .ivu-tabs-tab {
		width: 200px;
		text-align: center;
		font-size: 18px;
	}

	.content_box {
		margin: 80px auto;
		max-width: 1000px;
		
		.search_box{
			display: flex;
			flex-wrap: wrap;
			font-size: 14px;
			>div{
				margin: 10px;
				white-space: nowrap;
				cursor: pointer;
			}
			.btn1{
				background: linear-gradient(270deg, #2D85E2 2%, #5B43DF 100%);
				color: #fff;
				padding: 5px 15px;
			}
			.btn2{
				background: #767676;
				color: #fff;
				padding: 5px 15px;
			}
		}

		.cell_box {
			margin-top: 20px;

			.cell {
				display: flex;
				width: 100%;
				white-space: nowrap;
				font-size: 14px;
				padding: 10px 0;
				text-align: center;
				border-left: 1px solid #eee;
				border-right: 1px solid #eee;

				>div:first-child {
					width: 15%;
				}

				>div:nth-child(2) {
					width: 15%;
				}

				>div:nth-child(3) {
					width: 15%;
				}

				>div:nth-child(4) {
					width: 15%;
				}

				>div:nth-child(5) {
					width: 20%;
				}

				>div:nth-child(6) {
					width: 30%;
				}
			}

			.th {
				background-color: #49B3FF;
			}
			.td{
				cursor: pointer;
			}
			.td:hover{
				background-color: #eee;
			}
			.td:nth-child(odd){
				background-color: #D8D8D8;
			}
			.td:nth-child(even){
				border-bottom: 1px solid #eee;
			}
		}
	}
</style>
